import React, { useRef, useEffect } from 'react';

const ModalStructure = ({ children, onClose }) => {
  const modalRef = useRef(null); // Reference to the modal content

  // Close modal when clicked outside the content
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, );

  return (
    <div className="login-modal fixed inset-0 flex items-center justify-center">
      <div
        ref={modalRef}
        className="login-content bg-white p-6 rounded-lg shadow-lg relative"
        style={{ width: '500px', maxWidth: '90%', height: '500px' }} // Manually setting the width and height
      >
        {/* Modal Content */}
        {children}

        {/* Close Button */}
        <button
          className="absolute bg-white rounded-full shadow-lg text-2xl flex items-center justify-center"
          onClick={onClose}
          style={{
            top: '0px',   // Move the button above the modal
            right: '-45px', // Move the button to the right of the modal
            width: '30px',
            height: '30px',
            //border: '1px solid #ccc',
          }}
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default ModalStructure;
